import '@fortawesome/fontawesome-free/css/all.css';
import Main from './layouts/main/Main';
import Navbar from './layouts/navbar/Navbar';
import Footer from './layouts/footer/Footer';
import React from 'react';
import store from './redux/store';
import { Provider } from 'react-redux';

import 'typeface-roboto';
import { BrowserRouter as Router } from 'react-router-dom';
import { initializeHttpClient } from './config/axios-config';

const App = () => {
  initializeHttpClient(store);

  return (
    <Provider store={store}>
      <Router basename='/track-and-trace'>
        <div className='App'>
          <Navbar />
          <Main />
          <Footer />
        </div>
      </Router>
    </Provider>
  );
};

export default App;
